export const SortingDirection = {
    Ascending: 0,
    Descending: 1
}

export enum TruckTypes {
    Turbo = 5
}

